<div class="hf-comments-section">
  <div class="swiper-container" [swiper]="config">
    <div class="swiper-wrapper">
      <div class="comment-item swiper-slide" *ngFor="let comment of comments; index as i">
        <div class="top-content">
          <div class="top-img">
            <img src="/assets/images/health-first/quotation.svg" alt="image" />
          </div>
          <div class="comment-desc">
            {{comment.comment}}
          </div>
        </div>
        <div class="commented-author">
          <!-- <div class="avatar-wrapper">
            <img [src]="comment.profile" alt="profile img">
          </div> -->
          <div class="content">
            <div class="author-name">
              {{comment.name}}
            </div>
            <div class="ratings-wrapper">
              <ng-container *ngFor="let item of getRatingsArr(comment?.rating)">
                <img [src]="item" alt="healthfirst rating img"/>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>